module.exports = __webpack_public_path__ + "img/nodata.512137ad.png";